export const one = (lvl) => {
    return lvl % 2 === 1
}
export const two = (lvl) => {
    return (lvl & 2) === 2;
}
export const four = (lvl) => {
    return (lvl & 4) === 4;
}
export const eight = (lvl) => {
  return (lvl & 8) === 8;
}
export const sixteen = (lvl) => {
  return (lvl & 16) === 16;
}
export const thirtytwo = (lvl) => {
  return (lvl & 32) === 32;
}
export const sixtyfour = (lvl) => {
  return (lvl & 64) === 64;
}
